import { Card } from "@excalidraw/excalidraw/components/Card";
import { Dialog } from "@excalidraw/excalidraw/components/Dialog";
import { ToolButton } from "@excalidraw/excalidraw/components/ToolButton";
import {
  LoadIcon,
  exportToFileIcon,
} from "@excalidraw/excalidraw/components/icons";

import { useAtom, useSetAtom } from "../../app-jotai";
import { openFromFile } from "../cloudActions";
import { cloudBrowserDialogAtom, openChooserDialogAtom } from "../dialogState";

/**
 * The "Open" menu entry opens this chooser so the user can load a drawing
 * either from a local file or from their cloud workspace.
 */
export const OpenChooserDialog = () => {
  const [open, setOpen] = useAtom(openChooserDialogAtom);
  const openCloudBrowser = useSetAtom(cloudBrowserDialogAtom);

  if (!open) {
    return null;
  }

  const close = () => setOpen(false);

  return (
    <Dialog size="small" onCloseRequest={close} title="Open drawing">
      <div
        className="ExportDialog-cards"
        style={{ display: "flex", gap: "1rem" }}
      >
        <Card color="lime">
          <div className="Card-icon">{exportToFileIcon}</div>
          <h2>From file</h2>
          <div className="Card-details">
            Open an .excalidraw file from your device.
          </div>
          <ToolButton
            className="Card-button"
            type="button"
            title="From file"
            aria-label="From file"
            showAriaLabel={true}
            onClick={async () => {
              close();
              try {
                await openFromFile();
              } catch (error: any) {
                if (error?.name !== "AbortError") {
                  // eslint-disable-next-line no-console
                  console.error(error);
                }
              }
            }}
          />
        </Card>
        <Card color="primary">
          <div className="Card-icon">{LoadIcon}</div>
          <h2>From cloud</h2>
          <div className="Card-details">
            Browse and open a drawing saved in your cloud workspace.
          </div>
          <ToolButton
            className="Card-button"
            type="button"
            title="From cloud"
            aria-label="From cloud"
            showAriaLabel={true}
            onClick={() => {
              close();
              openCloudBrowser(true);
            }}
          />
        </Card>
      </div>
    </Dialog>
  );
};
